// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2w1RU","rightAdornment":"Header_rightAdornment__2iOFm"};